import { Component, OnInit, AfterViewInit, ViewChild, HostListener, ChangeDetectionStrategy, ChangeDetectorRef, Input, OnDestroy } from '@angular/core';
import {
    Router,
    NavigationEnd,
    RouteConfigLoadStart,
    RouteConfigLoadEnd,
    ResolveStart,
    ResolveEnd
} from '@angular/router';

import { Subscription, Observable } from "rxjs";
import { LayoutService } from '../../services/layout.service';
import { filter, map, shareReplay } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    selector: 'app-layout-container',
    templateUrl: './app-layout-container.component.html',
    standalone: false
})
export class AppLayoutContainerComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() showSidebar: boolean = true;
    @Input() showHeader: boolean = true;
    @Input() navigationPos: string = 'side'; // 'side' or 'top'

    public isModuleLoading: Boolean = false;
    private moduleLoaderSub: Subscription;
    private layoutConfSub: Subscription;
    private routerEventSub: Subscription;
    containerClasses = ''

    public scrollConfig = {}
    public layoutConf: any = {};
    public adminContainerClasses: any = {};

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(
        private router: Router,
        private layout: LayoutService,
        private cdr: ChangeDetectorRef,
        private breakpointObserver: BreakpointObserver
    ) {
        // Close sidenav after route change in mobile
        this.routerEventSub = router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((routeChange: NavigationEnd) => {
                this.layout.adjustLayout({ route: routeChange.url });
                this.scrollToTop();
            });
    }

    ngOnInit() {
        this.layoutConfSub = this.layout.layoutConf$.subscribe((layoutConf) => {
            this.layoutConf = layoutConf;
            this.adminContainerClasses = this.updateAdminContainerClasses(this.layoutConf);
            this.cdr.markForCheck();
            this.containerClasses = this.layout.containerClasses()
        });

        // FOR MODULE LOADER FLAG
        this.moduleLoaderSub = this.router.events.subscribe(event => {
            if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
                this.isModuleLoading = true;
            }
            if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
                this.isModuleLoading = false;
            }
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.layout.adjustLayout(event);
    }

    ngAfterViewInit() { }

    scrollToTop() {
        if (document) {
            setTimeout(() => {
                let element;
                if (this.layoutConf.topbarFixed) {
                    element = document.querySelector('#rightside-content-hold');
                } else {
                    element = document.querySelector('#main-content-wrap');
                }
                if (element) {
                    element.scrollTop = 0;
                }
            });
        }
    }

    updateAdminContainerClasses(layoutConf) {
        return {
            'navigation-top': layoutConf.navigationPos === 'top',
            'sidebar-full': layoutConf.sidebarStyle === 'full',
            'sidebar-compact': layoutConf.sidebarStyle === 'compact',
            'compact-toggle-active': layoutConf.sidebarCompactToggle,
            'sidebar-compact-big': layoutConf.sidebarStyle === 'compact' && layoutConf.sidebarCompactToggle,
            'sidebar-opened': layoutConf.sidebarStyle !== 'closed' && layoutConf.sidebarStyle !== 'compact',
            'sidebar-closed': layoutConf.sidebarStyle === 'closed',
            'fixed-topbar': layoutConf.topbarFixed
        }
    }

    sidebarMouseenter(e) {
        if (this.layoutConf.sidebarStyle === 'compact') {
            this.layout.publishLayoutChange({ sidebarCompactToggle: true })
        }
    }

    sidebarMouseleave(e) {
        if (this.layoutConf.sidebarStyle === 'compact') {
            this.layout.publishLayoutChange({ sidebarCompactToggle: false })
        }
    }

    ngOnDestroy() {
        if (this.moduleLoaderSub) {
            this.moduleLoaderSub.unsubscribe()
        }
        if (this.layoutConfSub) {
            this.layoutConfSub.unsubscribe()
        }
        if (this.routerEventSub) {
            this.routerEventSub.unsubscribe()
        }
    }
}
